const Footer = () => {
  return <div className="footer">&copy; 2016-2026 Mochitto Caffe</div>;
};

export default Footer;
